var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/chosenProduct.ts
import { logger } from "@adornis/base/logging.js";
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { BasicProduct } from "./basic-product.js";
var ChosenProduct = class extends AdornisEntity {
  static resolveID(entity) {
    if (!entity.product)
      logger.error(
        "Trying to resolve ID of PaymentProduct without nested product. This will throw merge errors. Please select at least .product._id in your selectionSet!"
      );
    return entity.product?._id;
  }
  get price() {
    const price = this.product.prices.find((p) => p._id === this.priceID);
    if (!price)
      throw new Error(
        `Could not get price with id ${this.priceID} from product ${this.product._id}. Are you sure the priceID you selected belongs to this product?`
      );
    return price;
  }
};
ChosenProduct._class = "ChosenProduct";
__decorateClass([
  Field((type) => BasicProduct)
], ChosenProduct.prototype, "product", 2);
__decorateClass([
  Field((type) => String)
], ChosenProduct.prototype, "priceID", 2);
__decorateClass([
  Field((type) => Int)
], ChosenProduct.prototype, "amount", 2);
ChosenProduct = __decorateClass([
  Entity()
], ChosenProduct);
export {
  ChosenProduct
};
